import { NgxLoggerLevel } from 'ngx-logger';

import { AppEnvironment } from './types';

export const environmentCommon: AppEnvironment = {
  production: false,
  apiBaseUrl: localStorage.getItem('apiBaseUrl') ?? window.location.origin + '/api',
  environment: 'local',
  logs: {
    logger: {
      level: NgxLoggerLevel.DEBUG,
    },
  },
  eid: {
    eidBaseUrl: 'https://top-stage.infocert.it/eid/start',
    TOFEReturnUrl: 'https://toponboarding-local.infocert.it',
    infocertIdp: 'https://identitycl.infocert.it',
    mysignUrl: 'https://mysigncl.infocert.it/',
    idpRecoveryUrl: 'https://identitycl.infocert.it/recovery',
    spidLevel: 'https://www.spid.gov.it/SpidL2',
  },
};
